/**
 * Product Description Enhancement
 * 
 * 1. ~~Converts h3 and h4 headings from uppercase to title case (each word capitalized)~~ [DISABLED]
 * 2. Implements expand/collapse functionality for product descriptions
 *    - Shows only 3 lines by default
 *    - "See More" button to expand, "See Less" to collapse
 * 
 * @file assets/product-description.js
 */

(function() {
    'use strict';
  
    
  
    function initProductDescription() {

  
      // Handle See More/Less toggle buttons
      document.querySelectorAll('.product-description-toggle').forEach(function(button) {
        // Skip if already initialized
        if (!button.dataset.initialized) {
          button.dataset.initialized = 'true';
          button.addEventListener('click', function() {
            const wrapper = this.closest('.product-description-wrapper');
            const toggleText = this.querySelector('.product-description-toggle-text');
            
            if (wrapper) {
              const isExpanded = wrapper.classList.contains('expanded');
              
              if (isExpanded) {
                wrapper.classList.remove('expanded');
                toggleText.textContent = 'See More';
              } else {
                wrapper.classList.add('expanded');
                toggleText.textContent = 'See Less';
              }
            }
          });
        }
      });
    }
  
    // Initialize on DOM ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initProductDescription);
    } else {
      initProductDescription();
    }
  
    // Re-initialize when product rerender happens (for variant changes)
    document.addEventListener('product:rerender', function() {
      setTimeout(initProductDescription, 100);
    });
  
    // Also initialize when new content is added (for AJAX page loads)
    const observer = new MutationObserver(function(mutations) {
      let shouldInit = false;
      mutations.forEach(function(mutation) {
        Array.from(mutation.addedNodes).forEach(function(node) {
          if (node.nodeType === 1 && (
            node.classList && node.classList.contains('product-description-wrapper') ||
            node.querySelector && node.querySelector('.product-description-wrapper')
          )) {
            shouldInit = true;
          }
        });
      });
      if (shouldInit) {
        setTimeout(initProductDescription, 50);
      }
    });
  
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  })();
  
  